import { getOpenPanelClientForJungleWebApp } from "./openpanel-client";
import { detectDeviceType } from "../../backend/utils/detect-device";
import { detectOS, getOrCreateDeviceUID } from "../../backend/utils/device-identity";
import { getStoredReferrerUserId } from "../../backend/utils/referrer-id";
import { getStoredSharerDevice } from "../sharer-device";

/**
 * `trackEvent` for pages where nobody is signed in: the marketing site (jungleai.com). It sends the same
 * base properties as the anonymous branch of `trackEvent` in helper-methods.ts. Device storage is
 * origin-scoped; cross-domain attribution uses the ws handoff and explicit landing context. This runs
 * without importing helper-methods, which would pull the whole app runtime (Firebase, the stores,
 * product providers) into the marketing site's bundle. The landing page A/B variant
 * is reported as a property on every marketing event instead.
 */
export async function trackAnonymousEvent(
  eventName: string,
  additionalEventProperties: Record<string, unknown>
): Promise<void> {
  try {
    const eventTrackingProperties: Record<string, unknown> = {
      platform: "Web",
      deviceType: detectDeviceType(),
      operatingSystem: detectOS(),
      dateTracked: new Date().toISOString(),
      deviceId: getOrCreateDeviceUID(),
    };
    const userReferrerId = await getStoredReferrerUserId();
    if (userReferrerId) eventTrackingProperties.userReferrerId = userReferrerId;
    const sharerDevice = getStoredSharerDevice();
    if (sharerDevice) eventTrackingProperties.sharerDevice = sharerDevice;
    getOpenPanelClientForJungleWebApp().track(eventName, { ...eventTrackingProperties, ...additionalEventProperties });
  } catch (e) {
    console.log("error in tracking event: ", e);
  }
}
